let env = Object.freeze({})

export const setEnv = (key, value) => {
  env = Object.freeze({ ...env, [key]: value })
}

export const getEnv = (key) => {
  return env[key]
}
